import React from "react"
import { Col, Container, Row } from "styled-bootstrap-grid"
import styled from "styled-components"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import breakpoints from "../../styles/breakpoints"
import Img from "gatsby-image"
import Button from "../Core/Button"
import WhatWeDoCards from "./WhatWeDoCards"

const Background = styled(Img)`
  position: absolute !important;
  height: 100%;
  width: 100%;
  top: 0;
  z-index: -1;
  @media (min-width: ${breakpoints.md}) {
    top: 0;
    img {
      object-fit: unset !important;
    }
  }
`
const ContainerStyled = styled(Col)`
  position: relative;
  height: 1400px;
  @media (min-width: ${breakpoints.sm}) {
    height: 930px;
  }
  @media (min-width: ${breakpoints.md}) {
    margin-top: 100px;
  }
  @media (min-width: ${breakpoints.lg}) {
    margin-top: 0px;
  }
`
const RowStyled = styled(Row)`
  margin: 0 auto;
  max-width: 1440px;
`
const ContentContainer = styled.div`
  height: inherit;
  display: grid;
  justify-content: center;
  align-items: center;
`
const ColStyled = styled(Col)`
  display: grid;
  padding: 60px 10px 20px;
  justify-content: center;
  align-items: center;
`

const WhatWeDoBlock = ({ 
    background, 
    ctaLabel, 
    ctaLink,
    ctaAriaLabel,
    cards 
  }) => {

  return (
    <ContainerStyled fluid>
      <Background fluid={background.childImageSharp.fluid} />
      <ContentContainer>
        <RowStyled>
          {cards.map((data, index) => (
            <WhatWeDoCards key={index} {...data} />
          ))}
          <ColStyled sm={12}>
            <Button link={ctaLink} aria-label={ctaAriaLabel}>{ctaLabel}</Button>
          </ColStyled>
        </RowStyled>
      </ContentContainer>
    </ContainerStyled>
  )
}

export default WhatWeDoBlock
